// extracted by mini-css-extract-plugin
export default {"product-specifications-list":"product-specifications-list_komD5KhC","uom-label":"uom-label_yd9NYwgI"};